import type { ComponentPropsWithRef } from "react";

export const CrossIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
    <path d="M28 24l16-16-4-4-16 16L8 4 4 8l16 16L4 40l4 4 16-16 16 16 4-4-16-16z" fill="currentColor" />
  </svg>
);
